module.exports = __webpack_public_path__ + "82bd5e14032fdddb64c0831b6d9f22f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_3.jpg
// module id = 1672
// module chunks = 5